import { computeContentKey, type TagDef } from '../utils/questionTag';

/**
 * 复盘/错题详情：答案解析区域展示本题考查的知识点标签。
 * selected 由上层用 computeSelectedKnowledgeTags 预先算好（仅已标注的标签）。
 * onRemoveTag 传入时（后台管理预览模式）每个胶囊右上角显示删除按钮，点击确认后删除该标注；
 * 学员端只读场景不传该回调，不显示删除按钮。
 */
export default function KnowledgeTagPills({ selected, onRemoveTag }: { selected?: TagDef[]; onRemoveTag?: (tag: TagDef) => void }) {
  if (!selected || selected.length === 0) return null;
  return (
    <div className="flex items-start gap-2 mb-2">
      <span className="text-gray-600 text-base shrink-0 pt-1">考查知识点：</span>
      <div className="flex flex-wrap gap-2">
        {selected.map(t => (
          <span key={t.id} className="inline-flex items-center gap-1.5 pl-4 pr-2 py-1 rounded-full text-base font-medium text-white"
            style={{ backgroundColor: t.color || '#3B82F6' }}>{t.name}
            {onRemoveTag && (
              <button
                type="button"
                title="删除此标签标注"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!confirm(`确定删除知识点标签「${t.name}」的标注吗？`)) return;
                  onRemoveTag(t);
                }}
                className="flex items-center justify-center w-4 h-4 rounded-full bg-white/25 text-white leading-none hover:bg-white/40 shrink-0"
                style={{ fontSize: '11px' }}
              >×</button>
            )}
          </span>
        ))}
      </div>
    </div>
  );
}

/** 按题目内容指纹从标注数据中取出本题已选的知识点标签（顺序跟随标签库实时排序） */
export function computeSelectedKnowledgeTags(
  question: { type?: string; content?: string; title?: string; score?: number },
  tags?: TagDef[],
  marks?: Record<string, string[]>
): TagDef[] {
  if (!tags || tags.length === 0 || !marks) return [];
  const contentKey = computeContentKey({ type: question.type, content: question.content, title: question.title, score: question.score });
  const selectedIds = new Set(marks[contentKey] || []);
  // 按标签库顺序（tags 已按管理页排序传入）输出，而非标注写入顺序
  return tags.filter(t => selectedIds.has(t.id));
}
